<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h5>Series Aims</h5>

                    <ul>
                        <li>
                            To understand that God longs for sinners to repent and be saved.
                        </li>
                        <li>
                            To understand that God relentlessly searches for the lost because he cares for them.
                        </li>
                        <li>
                            To understand that God rejoices whenever someone is saved and that we should rejoice too.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series examines the three parables that Jesus used to reply to his critics in Luke 15.
                        In each case something that was lost is found by the one to whom they belong and two
                        groups of people respond:
                    </p>

                    <ul>
                        <li>
                            God in heaven – in all three parables God’s reaction is rejoicing.
                            In fact he is more pleased when just one sinner repents than he is even with
                            those who are already saved (weeks 1 and 2). This will always be true no matter
                            what an individual has done in their life or how far they have turned away from him –
                            it is a cause for extravagant celebration (week 3).
                        </li>
                        <li>
                            People on earth – again, in all three parables the natural response
                            of those who love God should be to celebrate too (weeks 1 and 2). If we are unable
                            to rejoice with God there is something wrong with our hearts. This was true of the
                            Jewish leaders and it was true of the older son who thought of his father as a
                            slave-driver and disowned his brother. Their grumbling against Jesus and absence
                            of joy revealed their attitude towards God and his people (weeks 1, 2 and 3).
                        </li>
                    </ul>

                    <p>
                        These parables are a source of great comfort as we see God’s clear love
                        for us and for those who are lost. However, they are also a warning and
                        require us to examine our own hearts. As Christians our attitude towards
                        outsiders should be the same as God’s – we should long for all people to be saved;
                        care enough to join with God in his work of seeking the lost;
                        and rejoice with him when even one person repents and believes the good news.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - The Lost Sheep (Luke 15:1-17)
                    </p>
                    <p>
                        Lesson 2 - The Lost Coin (Luke 15:1-3, 8-10)
                    </p>
                    <p>
                        Lesson 3 - The Lost Son (Luke 15:1-3, 11-32)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Lost",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Lost`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God relentlessly searches for the lost because he cares for them\"",
                },
            ],
        };
    },
};
</script>
